import NotificationNumber from 'components/NotificationNumber';
import { PageHeadContainer, PageTitle } from 'components/PageHead';
import ProfileNavigation from 'components/profileNavigation';
import ProfileLink from 'components/profileNavigation/Link';
import React, { FC, useMemo } from 'react';
import useSWR from 'swr';
import AdminNotifications from 'types/notifications/AdminNotifications';
import ActionsRoutes from './Routes';

type ContextType = Record<string, never>;
export const MenteeEditContext = React.createContext({} as ContextType);
const { Provider } = MenteeEditContext;

const AdminActions: FC = ({ children }) => {
  const value = useMemo(() => ({}), []);

  return <Provider value={value}>{children}</Provider>;
};

const Head: FC = () => {
  return (
    <PageHeadContainer>
      <PageTitle>
        <h1>Actions à effectuer</h1>
      </PageTitle>
    </PageHeadContainer>
  );
};

const baseURL = '/admin/actions/';
const Navigation: FC = () => {
  const { data: adminNotifications } = useSWR<AdminNotifications>(
    '/user/notification/admin',
  );
  return (
    <ProfileNavigation>
      <ProfileLink to={baseURL}>
        Mentorat
        {adminNotifications && (
          <NotificationNumber
            number={
              adminNotifications.interruptionRequest +
              adminNotifications.menteeResetStatus
            }
          />
        )}
      </ProfileLink>
      <ProfileLink to={baseURL + 'mentor-formation'}>
        Formations mentor
        {!!adminNotifications?.mentorFormation && (
          <NotificationNumber number={adminNotifications.mentorFormation} />
        )}
      </ProfileLink>
    </ProfileNavigation>
  );
};

const Usage: FC = (props) => {
  return (
    <AdminActions {...props}>
      <Head />
      <Navigation />
      <ActionsRoutes />
    </AdminActions>
  );
};

export default Usage;
